import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getPersonalSchedaSpese, getSharedSchedaSpese, unhideSchedaSpese, setActiveTab, loadMoreSchedaSpese } from "../features/schedaSpese/schedaSpeseSlice";
import { getAllCategories } from "../features/categorie/categorieSlice";
import SingleScheda from "./SingleScheda";
import { useNavigate, NavLink, useParams } from "react-router-dom";
import Button from "react-bootstrap/Button";
import { toast } from "react-toastify";
import { logout } from "../features/auth/authSlice";
import Spinner from "./utils/Spinner";
import SingleSchedaNew from "./SingleScheda.refactored";
import { useState } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { FaUndo, FaPlus } from "react-icons/fa";

const GestioneError = {
  message: "Cannot read properties of null (reading 'token')",
};


function SchedaSpese({ handleShow }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { scope } = useParams();
  const { schedaSpese, isLoading, isLoadingMore, hasMore, isError, message } = useSelector(
    (state) => state.schedaSpese,
  );
  const { user } = useSelector((state) => state.auth);
  const { categorie, isLoading: categorieLoading } = useSelector((state) => state.categorie);
  const scopeFromUrl = scope === "personal" ? "personal" : "shared";
  const [key, setKey] = useState(scopeFromUrl);
  const [showHiddenSchede, setShowHiddenSchede] = useState(false);

  const visibleSharedSchede = schedaSpese.filter((s) => !s.hiddenForUser);
  const hiddenSharedSchede = schedaSpese.filter((s) => s.hiddenForUser);

  const handleUnhide = async (scheda) => {
    try {
      await dispatch(unhideSchedaSpese(scheda._id)).unwrap();
      toast.success(`"${scheda.titolo}" restored`);
    } catch (error) {
      toast.error(error?.message || error || "Error restoring scheda");
    }
  };

  useEffect(() => {
    setKey(scopeFromUrl);
    dispatch(setActiveTab(scopeFromUrl));
  }, [scopeFromUrl, dispatch]);

  // Fetch categorie once here (schede list load) instead of once per SingleSchedaNew/form.
  useEffect(() => {
    if (user && categorie.length === 0 && !categorieLoading) {
      dispatch(getAllCategories());
    }
  }, [user, categorie.length, categorieLoading, dispatch]);

  const onTabSelect = (nextKey) => {
    const tabKey = nextKey === "personal" ? "personal" : "shared";
    setKey(tabKey);
    navigate(`/note-spese/${tabKey}`);
  };

  useEffect(() => {
    if (user) {
      if (key === "shared") {
        dispatch(getSharedSchedaSpese())
          .unwrap()
          .then((response) => {
            // Success
          })
          .catch((error) => {
            if (error.includes("500")) {
              toast.error("Service unavailable, try again later");
            }
            console.error("Error Response:", error);
          });
      } else if (key === "personal") {
        dispatch(getPersonalSchedaSpese())
          .unwrap()
          .then((response) => {
            // Success
          })
          .catch((error) => {
            if (error.includes("500")) {
              toast.error("Service unavailable, try again later");
            }
            console.error("Error Response:", error);
          });
      }
    }
  }, [key, user, dispatch]);
  //è per il margine inferiore della pagina
  const isLastElement = (arr) => {
    const lastElement = arr[arr.length - 1];
    return lastElement._id;
  };

  const handleLoadMore = () => {
    dispatch(loadMoreSchedaSpese())
      .unwrap()
      .catch((error) => {
        toast.error(error?.message || error || "Error loading more schede");
      });
  };

  const LoadMoreButton = () =>
    hasMore ? (
      <div className="d-flex justify-content-center mt-2 mb-3">
        <Button
          variant="outline-secondary"
          size="sm"
          disabled={isLoadingMore}
          onClick={handleLoadMore}
        >
          {isLoadingMore ? "Loading..." : "Load more"}
        </Button>
      </div>
    ) : null;

  let isClosing = false;
  const goToLogin = () => {
    isClosing = true;
    dispatch(logout());
    navigate("/login");
  };

  function Msg() {
    return (
      <div>
        <span>
          Error: Please{" "}
          <span
            className="text-primary"
            role="button"
            onClick={() => goToLogin()}
          >
            <u>login</u>
          </span>{" "}
          to continue xxx
        </span>
      </div>
    );
  }

  if (isLoading) {
    return (
      <>
        <Spinner />
      </>
    );
  }
  if (isError) {
    return (
      <p className="text-danger">
        Error: {message}
        <br />
        Please
        <span
          className="text-primary"
          role="button"
          onClick={() => goToLogin()}
        >
          <u>login </u>
        </span>
        to continue
      </p>
    );
  }

  if (GestioneError.message === message) {
    toast.error(<Msg />, {
      toastId: "err1",
      autoClose: false,
      closeOnClick: true,
      draggable: false,
      pauseOnHover: true,
      onClose: () => goToLogin(),
    });
    return <>{isClosing && <p>Loading...</p>}</>;
  }

  return (
    <>
      <section>
        <div className="d-flex justify-content-between align-items-center mb-4 mt-0">
          <h2 className="mb-0 align-self-center">Expense list</h2>
            <div className="dashboard-btn-primary mb-0" onClick={handleShow}>
              <FaPlus size={12} />
              <p className="mb-0">New Sheet</p>
            </div>
        </div>
        <Tabs
          id="controlled-tab-example"
          activeKey={key}
          onSelect={onTabSelect}
          className="mb-3 custom-tabs"
        >
          <Tab eventKey="shared" title="Shared">
            {key === "shared" && visibleSharedSchede.length > 0 ? (
              <>
                {visibleSharedSchede.map((scheda, i, arr) => (
                  <div key={scheda._id}>
                    <div
                      style={{
                        marginBottom:
                          isLastElement(visibleSharedSchede) === scheda._id
                            ? "80px"
                            : "20px",
                      }}
                    >
                      <SingleSchedaNew key={scheda._id} scheda={scheda} />
                    </div>
                  </div>
                ))}
                {key === "shared" && <LoadMoreButton />}
              </>
            ) : (
              user ? (
                <>
                  <h5>Create a new list</h5>
                  <p>Expense list is empty, create a list to start your budget</p>
                  <div className="col-4">
                    <div className="dashboard-btn-primary" onClick={handleShow}>
                      <p className="mb-0">Create list</p>
                    </div>
                  </div>
                </>
              ) : (
                <p>
                  Please
                  <span
                    className="text-primary"
                    role="button"
                    onClick={() => goToLogin()}
                  >
                    <u> login </u>
                  </span>
                  to continue
                </p>
              )
            )}
            {key === "shared" && hiddenSharedSchede.length > 0 && (
              <div className="mt-2 pt-2 border-top">
                <button
                  type="button"
                  className="btn btn-link btn-sm text-secondary p-0"
                  onClick={() => setShowHiddenSchede((prev) => !prev)}
                >
                  {showHiddenSchede ? "Nascondi" : "Mostra"} schede nascoste ({hiddenSharedSchede.length})
                </button>
                {showHiddenSchede && (
                  <div className="mt-2">
                    {hiddenSharedSchede.map((scheda) => (
                      <div
                        key={scheda._id}
                        className="d-flex align-items-center justify-content-between p-2 rounded-3 mb-1 bg-light"
                      >
                        <span className="text-secondary text-sm">{scheda.titolo}</span>
                        <button
                          className="btn btn-link text-dark p-1 m-0 d-flex align-items-center gap-1"
                          onClick={() => handleUnhide(scheda)}
                        >
                          <FaUndo size={11} />
                          <span className="text-xs">Restore</span>
                        </button>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
          </Tab>
          <Tab eventKey="personal" title="Private" className="border border-0">
            {key === "personal" && schedaSpese.length > 0 ? (
              <>
                {schedaSpese.map((scheda, i, arr) => (
                  <div key={scheda._id}>
                    <div
                      style={{
                        marginBottom:
                          isLastElement(schedaSpese) === scheda._id
                            ? "80px"
                            : "20px",
                      }}
                    >
                      <SingleSchedaNew key={scheda._id} scheda={scheda} showsharedOrPersonal={key} />
                    </div>
                  </div>
                ))}
                {key === "personal" && <LoadMoreButton />}
              </>
            ) : (
              user ? (
                <>
                  <h5>Create a new list</h5>
                  <p>Expense list is empty, create a list to start your budget</p>
                  <div className="col-4">
                    <div className="dashboard-btn-primary" onClick={handleShow}>
                      <p className="mb-0">Create list</p>
                    </div>
                  </div>
                </>
              ) : (
                <p>
                  Please
                  <span
                    className="text-primary"
                    role="button"
                    onClick={() => goToLogin()}
                  >
                    <u> login </u>
                  </span>
                  to continue
                </p>
              )
            )}
          </Tab>
        </Tabs>
      </section>
    </>
  );
}

export default SchedaSpese;

// <>
//   {user ? (
//     <>
//       <h5>Create a new list</h5>
//       <p>Expence list is empty, create a list to start your budget</p>
//       <div className="col-4">
//         <div className="btn bg-gradient-dark" onClick={handleShow}>
//           <p className="mb-0">Create list</p>
//         </div>
//       </div>
//     </>
//   ) : (
//     <p>
//       Please
//       <span
//         className="text-primary"
//         role="button"
//         onClick={() => goToLogin()}
//       >
//         <u> login </u>
//       </span>
//       to continue
//     </p>
//   )}
// </>
